import AllNotifications from "../../../components/Notifications/AllNotifications";

function Notifications() {
    return ( 
        <div>
            <AllNotifications />
        </div>
     );
}

export default Notifications;